// Captcha de los formularios públicos (Cloudflare Turnstile) — auditoría de
// seguridad 2026-09-27, punto 2. Casi siempre es invisible: Cloudflare decide
// solo que es una persona y no pide nada.
//
// APAGADO mientras el servidor no tenga las claves: GET /captcha/config
// devuelve siteKey null, este hook no carga nada y el formulario funciona
// exactamente igual que antes.
import { useEffect, useRef, useState, useCallback } from 'react';
import { getCaptchaConfig } from '../api.js';

const SCRIPT = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let promesaDelScript = null;
function cargarScript() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!promesaDelScript) {
    promesaDelScript = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = SCRIPT;
      s.async = true;
      s.onload = () => resolve(window.turnstile);
      s.onerror = () => { promesaDelScript = null; reject(new Error('turnstile no cargó')); };
      document.head.appendChild(s);
    });
  }
  return promesaDelScript;
}

/**
 * { activo, token, widget, reiniciar }
 *   activo   — el servidor lo pide (hay claves).
 *   token    — lo que se manda en X-Captcha-Token; null hasta que Cloudflare responde.
 *   widget   — el elemento a pintar encima del botón de enviar.
 *   reiniciar— tras un envío (el token vale una sola vez).
 */
export function useCaptcha(lang) {
  const [siteKey, setSiteKey] = useState(null);
  const [token, setToken] = useState(null);
  const caja = useRef(null);
  const idWidget = useRef(null);

  useEffect(() => {
    let vivo = true;
    getCaptchaConfig()
      .then((cfg) => { if (vivo) setSiteKey(cfg?.siteKey || null); })
      .catch((e) => console.warn('[captcha] sin configuración; el formulario sigue sin captcha:', e?.message));
    return () => { vivo = false; };
  }, []);

  useEffect(() => {
    if (!siteKey || !caja.current) return undefined;
    let vivo = true;
    cargarScript()
      .then((ts) => {
        if (!vivo || !caja.current || idWidget.current != null) return;
        idWidget.current = ts.render(caja.current, {
          sitekey: siteKey,
          language: lang === 'es' ? 'es' : 'en',
          callback: (t) => setToken(t),
          'expired-callback': () => setToken(null),
          'error-callback': () => setToken(null),
        });
      })
      .catch((e) => console.warn('[captcha] no se pudo cargar Turnstile:', e?.message));
    return () => {
      vivo = false;
      if (idWidget.current != null && window.turnstile) {
        try { window.turnstile.remove(idWidget.current); } catch (e) { console.warn('[captcha] remove:', e?.message); }
      }
      idWidget.current = null;
    };
  }, [siteKey, lang]);

  const reiniciar = useCallback(() => {
    setToken(null);
    if (idWidget.current != null && window.turnstile) {
      try { window.turnstile.reset(idWidget.current); } catch (e) { console.warn('[captcha] reset:', e?.message); }
    }
  }, []);

  const widget = siteKey ? <div ref={caja} style={{ margin: '12px 0', minHeight: 65 }} /> : null;
  return { activo: !!siteKey, token, widget, reiniciar };
}
